import globalError from '../inner/globalerror';
import { warn } from '../utils/debug';
var errorFunc;
/**
* 提示全局错误
* @param {Nunber} code 错误代码
* @param {String} msg 错误提示
*/

export function showError(obj) {
  var error_code = obj.error_code,
      msg = obj.msg;
  warn("error_code:" + error_code + ", msg:" + msg);
  errorFunc && errorFunc({
    error_code: error_code,
    msg: msg
  });
}
export default function errorMixin(hybrid) {
  var hybridJs = hybrid;
  hybridJs.showError = showError;
  hybridJs.globalError = globalError;
  /**
   * 当出现错误时，会通过这个函数回调给开发者，可以拿到里面的提示信息
   * @param {Function} callback 开发者设置的回调(每次会监听一个全局error函数)
   * 回调的参数好似
   * msg 错误信息
   * error_code 错误码
   */

  hybridJs.error = function error(callback) {
    errorFunc = callback;
  };
}